import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Collapse,
  Card,
  Button,
  CardBody,
  CardTitle,
  CardText,
  Row,
  Col,
} from "reactstrap";
//import Modal from 'react-modal';
import classnames from "classnames";
import ShipmentHeader from "./shipmentHeader/ShipmentHeader.js";
//import { SearchBox } from './searchBox/searchBox.js';
import { ShipmentSearchBox } from "./shipmentSearchBox/shipmentSearchBox.js";
//import DataTable from './dataTable/dataTable.js'
import DataTableShipment from "./dataTableShipment/dataTableShipment.js";
import { userActions } from "../actions";
import BlockUi from "react-block-ui";
import "react-block-ui/style.css";
import { logoutCall } from "../util/userManager";
import "./shipment.css";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

const initialState = {
  fromDate: null,
  toDate: null,
  toDateErr: "",
  fromDateErr: "",
  showResults: false,
  showShipMentResult: false,
  blocking: false,
  deleteStatus: false,
  records: 0,
  status: 0,
  activeTab: "1",
  setTabs: true,
  depot: "",
  distributors: "",
  forwarder: "",
  document: "",
  transportion: "",
  showSearchResults: false,
  tableData: "",
  shipmentId: "",
  clearShipmentId: false,
  orgCode: "",
  clearSearch: false,
  clearBulk: false,
  bulkFilename: [],
  multipleDelete: [],
  searchResult: "",
  checkFromDate: false,
};
class Shipment extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
    this.logoutHandler = this.logoutHandler.bind(this);
    this.clearAllHandler = this.clearAllHandler.bind(this);
    this.searchChangeHandler = this.searchChangeHandler.bind(this);
    this.toDateChangeHandler = this.toDateChangeHandler.bind(this);
    this.fromDateChangeHandler = this.fromDateChangeHandler.bind(this);
    this.downloadFile = this.downloadFile.bind(this);
    this.checkDates = this.checkDates.bind(this);
    this.paginationHandler = this.paginationHandler.bind(this);
    this.countDot = this.countDot.bind(this);
    this.searchResultShipmentHandler =
      this.searchResultShipmentHandler.bind(this);
    this.autoOnChange = this.autoOnChange.bind(this);
    this.bulkdownloadFile = this.bulkdownloadFile.bind(this);
    this.multipleDeleteFile = this.multipleDeleteFile.bind(this);
  }

  componentWillMount() {
    console.log("inside will mount setting to initial state");
    this.setState(initialState);
    sessionStorage.setItem("isAuthenticated", false);
  }

  componentWillReceiveProps(nextProps) {
    console.log("nextProps:", nextProps);
    if (nextProps.tableData) {
      this.setState({ tableData: nextProps.tableData });
      this.setState({ records: nextProps.tableData.records });
    } else {
      this.setState({ records: 0 });
    }
    this.setState({ blocking: nextProps.blocking });
    this.setState({ status: nextProps.status });
    this.setState({ url: nextProps.url });
  }

  logoutHandler = (e) => {
    console.log(" logout call: ");
    e.preventDefault();
    logoutCall();
  };

  clearAllHandler() {
    // this.props.user.distributor[0]=this.props.user.distributor[0].displayValue;
    console.log("this.state.value:", this.state);
    //this.state=initialState;
    this.setState(initialState);
    this.state.bulkFilename = [];
    this.setState({
      clearShipmentId: true,
    });
    this.setState({ clearBulk: true });

    console.log("clearHandle:", this.state);
    console.log("clearHandle props:", this.props);
    this.setState({ showShipMentResult: false });
    const { dispatch } = this.props;
    dispatch(userActions.resetTable());
  }

  searchResultShipmentHandler(e) {
    this.state.searchResult = e;
    e.preventDefault();
    const { dispatch } = this.props;
    console.log("search State:", this.state);
    this.setState({ clearSearch: true });
    this.setState({ clearBulk: false });
    if (this.state.checkFromDate) {
      this.setState({ toDate: null, toDateErr: "To date should be mandatory" });
    } else {
      if (this.state.fromDate) {
        var startFromDate = moment(this.state.fromDate).format("YYYY-MM-DD");
      } else {
        startFromDate = "";
      }
      if (this.state.toDate) {
        var endToDate = moment(this.state.toDate).format("YYYY-MM-DD");
      } else {
        endToDate = "";
      }
      if (this.state.depot === "--Select--") {
        this.state.depot = "";
      }
      if (this.state.forwarder === "--Select--") {
        this.state.forwarder = "";
      }
      if (this.state.document === "--Select--") {
        this.state.document = "";
      }
      if (this.state.transportion === "--Select--") {
        this.state.transportion = "";
      }
      if (this.state.distributors === "--Select--") {
        this.state.distributors = "";
      }
      const reqBody = {
        shipmentId: this.state.shipmentId,
        distributorId: this.state.distributors,
        documentId: this.state.document,
        depotId: this.state.depot,
        forwarderId: this.state.forwarder,
        transportationId: this.state.transportion,
        startDate: startFromDate,
        endDate: endToDate,
        orgCode: this.props.loggedInUser.user.orgCode,
        role: this.props.loggedInUser.user.roles[0],
        index: 0,
        size: 10,
        sortOrder: "",
        sortColumn: "",
      };
      this.setState({ tableData: null });
      console.log("Request Body:", reqBody);
      dispatch(userActions.getShipment("/searchData/search", reqBody));
      console.log("table Data response:", this.props.data);
      this.setState({ tableData: this.props.data });
      this.setState({ showShipMentResult: true });
    }
  }

  paginationHandler(pageNumber, pageSize, sortColumnName, sortOrder) {
    const { dispatch } = this.props;
    this.state.bulkFilename = [];
    this.state.multipleDelete = [];
    this.setState({ clearSearch: false });
    // var formatfromDate;
    // var formattoDate;
    // if(this.state.fromDate) {
    // 	formatfromDate = moment(this.state.fromDate).format('YYYY-MM-DD');
    // }
    // if(this.state.toDate) {
    // 	formattoDate = moment(this.state.toDate).format('YYYY-MM-DD');
    // }
    console.log("search Pagination State:", this.state);
    if (this.state.fromDate) {
      var startFromDate = moment(this.state.fromDate).format("YYYY-MM-DD");
    } else {
      startFromDate = "";
    }
    if (this.state.toDate) {
      var endToDate = moment(this.state.toDate).format("YYYY-MM-DD");
    } else {
      endToDate = "";
    }
    if (this.state.depot === "--Select--") {
      this.state.depot = "";
    }
    if (this.state.forwarder === "--Select--") {
      this.state.forwarder = "";
    }
    if (this.state.document === "--Select--") {
      this.state.document = "";
    }
    if (this.state.transportion === "--Select--") {
      this.state.transportion = "";
    }
    if (this.state.distributors === "--Select--") {
      this.state.distributors = "";
    }
    console.log(
      "props:",
      this.props,
      "state:",
      this.state,
      "pageNumber:",
      pageNumber,
      "pageSize:",
      pageSize,
      "sortColumnName:",
      sortColumnName,
      "sortOder:",
      sortOrder
    );
    const reqBody = {
      shipmentId: this.state.shipmentId,
      distributorId: this.state.distributors,
      documentId: this.state.document,
      depotId: this.state.depot,
      forwarderId: this.state.forwarder,
      transportationId: this.state.transportion,
      startDate: startFromDate,
      endDate: endToDate,
      orgCode: this.props.loggedInUser.user.orgCode,
      role: this.props.loggedInUser.user.roles[0],
      size: pageSize ? pageSize : 10,
      index: pageNumber - 1,
      sortOrder: sortOrder,
      sortColumn: sortColumnName,
    };

    this.setState({ tableData: [] });
    console.log("Request Body:", reqBody);
    dispatch(userActions.getShipment("/searchData/search", reqBody));
    console.log("table Data response:", this.props.data);
    this.setState({ tableData: this.props.data });
    this.setState({ showShipMentResult: true });
  }
  autoOnChange = (e) => {
    console.log("autoOnChange  event:", e);
    // const { name, value } = e.target;
    // console.log('shipname:',name,'shipvalue:',value);
    this.state.shipmentId = e;
  };

  searchChangeHandler(e) {
    console.log("event:", e);
    const { name, value } = e.target;
    console.log("name:", name, "value:", value);

    if (value === "") {
      this.setState({ [name]: "" });
    } else {
      this.setState({ [name]: value });
    }
  }

  countDot(str) {
    var letter_Count = 0;
    for (var position = 0; position < str.length; position++) {
      if (str.charAt(position) === ".") {
        letter_Count += 1;
      }
    }
    return letter_Count;
  }

  toDateChangeHandler(date, key) {
    this.setState({ toDate: date, toDateErr: "" });
    this.setState({ checkFromDate: false });
    this.checkDates(this.state.fromDate, date);
  }

  fromDateChangeHandler(date, key) {
    //console.log('date:',date._d);
    this.setState({ fromDate: date, fromDateErr: "" });
    this.setState({ checkFromDate: true });
    console.log("fromDate:", this.state.fromDate);
    this.checkDates(date, this.state.toDate);
  }

  checkDates(fDate, tDate) {
    console.log("fDate:", fDate, "tDate:", tDate);
    if (fDate && tDate) {
      this.setState({ checkFromDate: false });
      if (tDate < fDate) {
        this.setState({
          toDate: null,
          toDateErr: "To date should be greater than From date",
        });
      }
    } else {
      if (fDate === null) {
        this.setState({
          fromDate: null,
          fromDateErr: " From date should be mandatory",
        });
      }
    }
  }

  downloadFile(e) {
    console.log("File download function.");
    const { dispatch } = this.props;
    e.preventDefault();
    console.log("eventDownload:", e.target.attributes);
    const { filename } = e.target.attributes;
    console.log("fileName:", filename.value);
    // const invoiceDate = moment(invdate.value, 'DD/MM/YYYY').format('YYYY-MM-DD');

    const reqData = {
      filename: filename.value,
    };
    console.log("reqData:", reqData.filename);
    //var url= dispatch(userActions.getShipment("/shipmentData/search",reqBody));
    // let token = this.props.user['x-access-token'];
    dispatch(
      userActions.downloadFileShipment(
        "/downloadData/download?key=" + reqData.filename,
        reqData
      )
    );
  }
  bulkdownloadFile(e) {
    console.log("Multiple File download function.", e);
    const { dispatch } = this.props;
    //e.preventDefault();
    this.state.bulkFilename = e;
    const reqData = {
      fileNamesArray: this.state.bulkFilename,
    };

    console.log("Multiple fileName:", this.state.bulkFilename);
    dispatch(
      userActions.bulkDownloadFile(
        "/downloadData/bulkdownload",
        this.state.bulkFilename
      )
    );
  }
  multipleDeleteFile(e) {
    const { dispatch } = this.props;
    console.log("search State:", this.state);
    this.setState({ clearSearch: true });
    if (this.state.fromDate) {
      var startFromDate = moment(this.state.fromDate).format("YYYY-MM-DD");
    } else {
      startFromDate = "";
    }
    if (this.state.toDate) {
      var endToDate = moment(this.state.toDate).format("YYYY-MM-DD");
    } else {
      endToDate = "";
    }
    if (this.state.depot === "--Select--") {
      this.state.depot = "";
    }
    if (this.state.forwarder === "--Select--") {
      this.state.forwarder = "";
    }
    if (this.state.document === "--Select--") {
      this.state.document = "";
    }
    if (this.state.transportion === "--Select--") {
      this.state.transportion = "";
    }
    if (this.state.distributors === "--Select--") {
      this.state.distributors = "";
    }
    const reqBody = {
      shipmentId: this.state.shipmentId,
      distributorId: this.state.distributors,
      documentId: this.state.document,
      depotId: this.state.depot,
      forwarderId: this.state.forwarder,
      transportationId: this.state.transportion,
      startDate: startFromDate,
      endDate: endToDate,
      orgCode: this.props.loggedInUser.user.orgCode,
      role: this.props.loggedInUser.user.roles[0],
      index: 0,
      size: 10,
      sortOrder: "",
      sortColumn: "",
    };
    this.state.multipleDelete = e;
    const requestBody = {
      username: this.props.loggedInUser.user.userName,
      fileNamesArray: this.state.multipleDelete,
    };
    console.log("MultipleDeleteData:", this.state.multipleDelete);
    confirmAlert({
      title: "Delete Confirmation alert box",
      message:
        "Do You Want To Delete" +
        "  " +
        this.state.multipleDelete.length +
        "  " +
        "file?",
      buttons: [
        {
          label: "Ok",
          onClick: () => {
            dispatch(
              userActions.deleteFile(
                "/deleteData/bulkdelete",
                requestBody,
                reqBody,
                "/searchData/search"
              )
            );
            console.log("DeleteStatus:", this.state.deleteStatus);
          },
        },
        {
          label: "Cancel",
        },
      ],
    });
    //console.log("DeleteStatus outside:", this.state.deleteStatus);

    //this.state.searchResultShipmentHandler(this.state.searchResult);
    this.setState({ deleteStatus: true });
  }
  componentWillUnmount() {
    this.setState({ showResults: true });
    this.setState({ showShipMentResult: true });
  }

  render() {
    // Below condition will set default value, when there is no data available
    // console.log('Distributor:',this.props.user.distributor);
    // //this.props.user.distri = this.props.user.distributors ? this.props.user.distributors : [];

    // console.log("this.props.showResults:" + this.state.showResults);
    console.log("LogginUserData:", this.props.loggedInUser.user);
    console.log("tableData:", this.state.tableData);
    console.log("this.props.data:", this.props.loggedInUser.user.documentTypes);
    console.log("this.state delete Status:", this.state.deleteStatus);

    var document = [{ docType: "--Select--" }];
    for (
      var i = 0;
      i < this.props.loggedInUser.user.documentTypes.length;
      i++
    ) {
      document.push({
        docType: this.props.loggedInUser.user.documentTypes[i].docType,
        id: this.props.loggedInUser.user.documentTypes[i].id,
      });
    }
    console.log("forwarder:", document);
    var forwarder = [{ code: "--Select--" }];
    if (this.props.loggedInUser.user.forwarders != null)
      for (var i = 0; i < this.props.loggedInUser.user.forwarders.length; i++) {
        forwarder.push({
          code: this.props.loggedInUser.user.forwarders[i].code,
          id: this.props.loggedInUser.user.forwarders[i].id,
        });
      }
    console.log("forwarder:", forwarder);

    var depot = [{ code: "--Select--" }];
    if (this.props.loggedInUser.user.depots != null)
      for (var i = 0; i < this.props.loggedInUser.user.depots.length; i++) {
        depot.push({
          code: this.props.loggedInUser.user.depots[i].code,
          id: this.props.loggedInUser.user.depots[i].id,
        });
      }
    console.log("depot:", depot);

    var transportion = [{ transType: "--Select--" }];
    for (
      var i = 0;
      i < this.props.loggedInUser.user.transportationTypes.length;
      i++
    ) {
      transportion.push({
        transType:
          this.props.loggedInUser.user.transportationTypes[i].transType,
        id: this.props.loggedInUser.user.transportationTypes[i].id,
      });
    }
    console.log("transportion:", transportion);

    var distributors = [{ distNameCode: "--Select--" }];
    if (this.props.loggedInUser.user.trdDistributors != null)
      for (
        var i = 0;
        i < this.props.loggedInUser.user.trdDistributors.length;
        i++
      ) {
        distributors.push({
          distNameCode:
            this.props.loggedInUser.user.trdDistributors[i].distNameCode,
          id: this.props.loggedInUser.user.trdDistributors[i].id,
        });
      }
    console.log("distributors:", distributors);

    console.log("Shipment:", this.props.loggedInUser.user.shipments);
    var shipmentCode = [];
    for (var i = 0; i < this.props.loggedInUser.user.shipments.length; i++) {
      shipmentCode.push({
        shipmentId: this.props.loggedInUser.user.shipments[i].shipmentId,
      });
    }
    // for(var j=0;i<this.state.tableData.length;j++){
    //  this.state.tableData.push({'id':j});
    // }
    console.log("shipmentDocument:", shipmentCode);
    return (
      <div id="content" className="col-md-12 col-sm-12 col-xs-12">
        <BlockUi
          tag="div"
          blocking={this.state.blocking}
          message="Loading, please wait"
          keepInView
        >
          <ShipmentHeader
            logoutUser={this.logoutHandler}
            username={this.props.loggedInUser.user.userName}
            roles={this.props.loggedInUser.user.roles}
            page={"TME Parts Supply Chain Document Portal"}
          />
          <ShipmentSearchBox
            document={document}
            forwarder={forwarder}
            depot={depot}
            transportion={transportion}
            distributors={distributors}
            shipmentCode={shipmentCode}
            data={this.state}
            onChangeHandler={this.searchChangeHandler}
            onSearchShipmentHandler={this.searchResultShipmentHandler}
            fromDate={this.state.fromDate}
            toDate={this.state.toDate}
            onResetHandler={this.clearAllHandler}
            toDateChangeHandler={this.toDateChangeHandler}
            fromDateChangeHandler={this.fromDateChangeHandler}
            role={this.props.loggedInUser.user.roles[0]}
            autoOnChange={this.autoOnChange}
          />
          <DataTableShipment
            data={this.state.tableData}
            paginationHandler={this.paginationHandler}
            showShipMentResult={this.state.showShipMentResult}
            searchClear={this.state.clearSearch}
            bulkClear={this.state.clearBulk}
            onDownloadHandler={this.downloadFile}
            onBulkDowloadHandler={this.bulkdownloadFile}
            onMultipleDeleteHandler={this.multipleDeleteFile}
            deleteStatus={this.state.deleteStatus}
            role={this.props.loggedInUser.user.roles[0]}
          />
        </BlockUi>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { loggedInUser } = state.loginReducer;
  console.log("LogginUser:", loggedInUser);
  const { tableData, blocking, deleteStatus } = state.searchData;
  return {
    loggedInUser,
    tableData,
    blocking,
    deleteStatus,
  };
}

const connectedLoginPage = connect(mapStateToProps)(Shipment);
export { connectedLoginPage as Shipment };
